import { render, staticRenderFns } from "./StepInformacionDerivacion.vue?vue&type=template&id=149af762"
import script from "./StepInformacionDerivacion.vue?vue&type=script&lang=js"
export * from "./StepInformacionDerivacion.vue?vue&type=script&lang=js"
import style0 from "./StepInformacionDerivacion.vue?vue&type=style&index=0&id=149af762&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports